<template>
  <div>
    <button
      class="mylisting-button danger-button"
      v-if="hasReportProblemButtonCheck(job)"
      style="margin-right: 1px"
      @click="handleClickReportProblemButton(job)"
    >
      {{ clientReportProblemButtonText }}
    </button>
    <button
      :key="'BUTTONS.REVIEW_REPORT_BUTTON'"
      class="mylisting-button dark-button"
      v-if="hasReviewReportButtonCheck(job)"
      style="margin-right: 1px"
      @click="showReviewReportsDialog(job)"
    >
      {{ getLabelByKeys('BUTTONS.REVIEW_REPORT_BUTTON') }}
    </button>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import { CLIENT_BOOKING_SETTINGS } from "../../../constants/agency-settings/job-settings";
import {
  FORM_TYPE,
} from "../../../constants/custom-define-type";

export default {
  name: "ReportProblemButtons",
  props: {
    user: Object,
    job: Object
  },
  data() {
    return {
      FORM_TYPE: FORM_TYPE,
      CLIENT_BOOKING_SETTINGS,
    }
  },
  computed: {
    ...mapGetters([
      "clientHasReportProblemButton",
      "clientReportProblemButtonText",
      "clientReportProblemUploadFilesLabel",
      "clientReportProblemUploadFilesDescription",
      "clientReportProblemNoteLabel",
      "clientReportProblemNotificationEmails",
      "clientReportProblemNewJobStatus",
      "listShiftJobStatusesCancelled"
    ]),
    reviewReportsHeader() {
      return [
        { displayLabel: "Note", model: "note" },
        { displayLabel: "Files", model: "files" },
        { displayLabel: "Date", model: "report_date" },
      ];
    },
  },
  methods: {
    ...mapActions([
      "updateJob",
    ]),
    handleClickReportProblemButton(job) {
      this.showInputDialog({
        title: "Please input the following information",
        listFields: [
          {
            type: FORM_TYPE.LIST_FILES,
            label: this.clientReportProblemUploadFilesLabel,
            description: this.clientReportProblemUploadFilesDescription,
            isRequired: false,
            model: "files",
            name: "File",
          },
          {
            type: FORM_TYPE.TEXTAREA,
            label: this.clientReportProblemNoteLabel,
            isRequired: false,
            model: "note",
          },
        ],
        onSubmitCallback: async (info) => {
          const res = await axios.post("/api/jobreports/", {
            ...info,
            job: job.id,
            user: this.user.id,
          });

          this.sendEmail(
            {
              ...this.$store.getters.clientReportProblemEmailTemplate,
              file_urls: info.files,
              recipients: this.clientReportProblemNotificationEmails,
            },
            this.clientReportProblemButtonText,
            this.user.first_name + " " + this.user.last_name,
            this.user.id,
            this.clientReportProblemNoteLabel,
            info.note,
            this.getDateString(job.date),
            job.id
          );
          // Update job status
          if (this.clientReportProblemNewJobStatus) {
            await this.updateJob({
              jobId: job.id,
              info: {
                status: this.clientReportProblemNewJobStatus,
              },
            });
          }
          this.$emit('reload');
        },
      });
    },
    hasReportProblemButtonCheck(job) {
      if (!this.clientHasReportProblemButton) {
        return false;
      }
      if (this.listShiftJobStatusesCancelled.includes(job.status)) {
        return false;
      }
      return true;
    },
    hasReviewReportButtonCheck(job) {
      if (!this.clientHasReportProblemButton || !job.reports) {
        return false;
      }
      return true;
    },
    async showReviewReportsDialog(job) {
      this.job = job;
      const reports = await this.getReports(job);
      this.showInfoDialog({
        title: "Reported Problems",
        listTableHeaders: this.reviewReportsHeader,
        listRows: reports,
      });
    },
    async getReports(job) {
      const res = await axios.get(`/api/jobreports/?job=${job.id}&user=${this.user.id}`);
      return res.data.map(report => {
        if (report.date) {
          report.report_date = `${new Date(report.date).toDateString()} at ${new Date(report.date).toLocaleTimeString()}`
        }
        return report;
      });
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/bookings/ReportProblemButtons.vue